import type { ApolloError } from '@apollo/client';
import { useQuery } from '@apollo/client';

import type { GetLineItemNotesQuery } from '../../../../apis/graphql';
import GET_LINE_ITEM_NOTES from './queries/getLineItemNotes';

export type UseFetchLineItemNotesResponse = {
  data?: GetLineItemNotesQuery['getLineItemNotes'];
  loading: boolean;
  error?: ApolloError;
};

export const useFetchLineItemNotes = ({ lineItemId }: { lineItemId?: string }): UseFetchLineItemNotesResponse => {
  const { data, loading, error } = useQuery<GetLineItemNotesQuery, { lineItemId?: string }>(GET_LINE_ITEM_NOTES, {
    variables: {
      lineItemId,
    },
    skip: !lineItemId,
  });

  return {
    data: data?.getLineItemNotes,
    loading,
    error,
  };
};

export default useFetchLineItemNotes;
